import { styled } from "@mui/material/styles";
import { NavLink } from "react-router";

export const Root = styled(NavLink)(({ theme }) => ({
  display: "block",
  height: "100%",
  padding: theme.spacing(1.5, 2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  color: "inherit",
  textDecoration: "none",
  transition: theme.transitions.create(["background-color", "border-color"], {
    duration: theme.transitions.duration.shorter,
  }),

  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.text.primary,
  },
}));
